import React from 'react';
import { useTranslation } from 'react-i18next';
import 'react-range-slider-input/dist/style.css';

type FilterKey =
  | 'mct'
  | 'srbm'
  | 'srst'
  | 'smst'
  | 'vulnerabilities'
  | 'heatmap'
  | 'archive'
  | 'filter'
  | 'encounters'
  | 'heatmapMct'
  | 'heatmapSRBM'
  | 'heatmapSRST'
  | 'heatmapSMST'
  | 'srbmFilter'
  | 'snapsFilter';

interface FilterDatePopupProps {
  filters: {
    filter: boolean;
    srbmFilter: string;
    snapsFilter: string;
    [key: string]: any;
  };
  onFilterChange: (filter: FilterKey, value: any) => void;
  onClose: () => void;
}

const FilterDatePopup: React.FC<FilterDatePopupProps> = ({ filters, onFilterChange, onClose }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    onFilterChange('srbmFilter', 'all');
    onFilterChange('snapsFilter', 'all');
    onFilterChange('filter', false);
    onClose();
  };

  const srbmOptions = [
    { id: 'all', label: t('MapSettings.srbmFilterAll') },
    { id: 'consumption', label: t('MapSettings.srbmFilterConsumption') },
    { id: 'no_consumption', label: t('MapSettings.srbmFilterNoConsumption') },
    { id: 'any_activity', label: t('MapSettings.srbmFilterAnyActivity') },
  ];

  const snapsOptions = [
    { id: 'all', label: t('MapSettings.srbmFilterAll') },
    { id: 'captured', label: t('MapSettings.mctAndSnapsFilterCaptured') },
    { id: 'not_captured', label: t('MapSettings.mctAndSnapsFilterNotCaptured') },
    { id: 'any_activity', label: t('MapSettings.srbmFilterAnyActivity') },
  ];

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        background: 'white',
        border: '1px solid #ccc',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
        zIndex: 1,
        cursor: 'default',
      }}
      onClick={e => e.stopPropagation()}
      onWheel={e => e.stopPropagation()}
      onTouchMove={e => e.stopPropagation()}
      onPointerDown={e => e.stopPropagation()}
    >
      <div className="border-bottom border-1">
        <div
          className="d-flex justify-content-between align-items-center pb-1"
          style={{ padding: '8px 16px', paddingBottom: '0px' }}
        >
          <div style={{ fontWeight: 700, fontSize: 18, color: '#3a3a6a' }}>{t('MapSettings.filter')}</div>
          <button
            className="btn btn-light waves-effect btn-sm fs-5 fw-semibold"
            style={{ borderRadius: '50%', width: '32px', height: '32px', padding: 0 }}
            onClick={handleClose}
          >
            <i className="ri-close-line" />
          </button>
        </div>
      </div>

      <div className="border-bottom border-1" style={{ padding: '12px 16px' }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#3a3a6a', marginBottom: '8px' }}>
          {t('MapSettings.SRBMFilter')}
        </div>
        <div className="d-flex flex-column gap-2">
          {srbmOptions.map(option => (
            <label
              key={option.id}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: 0 }}
            >
              <input
                type="radio"
                name="srbmFilter"
                value={option.id}
                checked={filters.srbmFilter === option.id}
                onChange={e => onFilterChange('srbmFilter', e.target.value)}
                style={{ cursor: 'pointer', color: '#3a3a6a', accentColor: '#6c3eb8' }}
              />
              <span className="fs-13">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div style={{ padding: '12px 16px' }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#3a3a6a', marginBottom: '8px' }}>
          {t('MapSettings.MCTAndSnapsFilter')}
        </div>
        <div className="d-flex flex-column gap-2">
          {snapsOptions.map(option => (
            <label
              key={option.id}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: 0 }}
            >
              <input
                type="radio"
                name="snapsFilter"
                value={option.id}
                checked={filters.snapsFilter === option.id}
                onChange={e => onFilterChange('snapsFilter', e.target.value)}
                style={{ cursor: 'pointer', color: '#3a3a6a', accentColor: '#6c3eb8' }}
              />
              <span className="fs-13">{option.label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterDatePopup;
